import React from 'react';
import { useBlossomEnabled } from './useBlossomEnabled';
import { useBlossomSeason } from './useBlossomSeason';

const BlossomToggle = () => {
  const [enabled, toggle] = useBlossomEnabled();
  const [, season] = useBlossomSeason();

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={enabled ? 'Disable falling petals' : 'Enable falling petals'}
      aria-pressed={enabled}
      title={enabled ? `Disable ${season.name} petals` : 'Enable petals'}
      className={'blossom-toggle' + (enabled ? ' is-on' : ' is-off')}
      data-season={season.name}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 19 C 5 11, 11 5, 19 5 C 19 13, 13 19, 5 19 Z"
          fill={enabled ? season.icon : 'transparent'}
          stroke={season.stroke}
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path
          d="M5 19 L 18 6"
          stroke={season.stroke}
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <line
          className="blossom-toggle-strike"
          x1="4"
          y1="20"
          x2="20"
          y2="4"
          stroke={season.stroke}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};

export default BlossomToggle;
